import { apolloClient } from "@/entities/graphql";
import { authMiddleware, keycloakContextLink } from "@/features/auth";
import { from } from "@apollo/client";

// eslint-disable-next-line @typescript-eslint/require-await
export async function initApollo() {
  apolloClient.setLink(
    from([keycloakContextLink, authMiddleware, apolloClient.link]),
  );
}
